import { FunctionComponent, memo } from "react";
import { faCalendar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import { SelectEnum } from "@edgetier/select";
import { SubmitOnChange } from "@edgetier/components";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import { IProps } from "./agent-interactions-volume-chart-filters.types";
import "./agent-interactions-volume-chart-filters.scss";

/**
 * Filter options for agent's interactions volume chart
 * @param props.initialValues   Filter initial values
 * @param props.onChange        Function called when the form is submitted
 * @returns Form containing options for group type
 */
const AgentInteractionsVolumeChartFilters: FunctionComponent<IProps> = ({ initialValues, onChange }) => {
    return (
        <Formik initialValues={initialValues} onSubmit={onChange}>
            <Form className="agent-interactions-volume-chart-filters" name="agent-interactions-volume-chart-filters">
                <div className="field field-inline">
                    <div className="field-inline__icon">
                        <FontAwesomeIcon icon={faCalendar} />
                    </div>
                    <SelectEnum
                        description="group"
                        isClearable={false}
                        name="timePeriodGroupBy"
                        items={TimePeriodGroupBy}
                        placeholder="Group by..."
                        isSingleSelect
                        isSearchable={false}
                        isFilter={false}
                    />
                </div>

                <SubmitOnChange />
            </Form>
        </Formik>
    );
};

export default memo(AgentInteractionsVolumeChartFilters);
